import { IonButton, IonIcon } from '@ionic/react';
import React from 'react';

import useInView from '@/hooks/useInView';
import { checkmark, checkmarkOutline } from 'ionicons/icons';

import './Plan.css';

interface PlanProps {
  title: string;
  description: string;
  originalPrice: number;
  price: number;
  discountPercentage: number;
  isPopular?: boolean;
}

const Plan: React.FC<PlanProps> = ({
  title,
  description,
  originalPrice,
  price,
  discountPercentage,
  isPopular = false
}) => {
  const benefits = [
    'Unlimited appointments',
    'Unlimited patient reminders',
    'Exclusive booking website',
    'All features included'
  ];

  const [ref, inView] = useInView({
    triggerOnce: true
  });

  const requestDemo = () => {
    window.open('https://m.me/OdontoPhilippines', '_blank');
  };

  return (
    <div
      className={`plan ${isPopular ? 'planPopular' : ''} ${inView ? 'inView' : ''}`}
      ref={ref}
    >
      {isPopular && <div className="planBadge">Most Popular</div>}

      <div className="planHeader">
        <p className="planTitle">{title}</p>
        <p className="planDescription">{description}</p>
      </div>

      <div className="planPrice">
        <div className="priceContainer">
          <div className="discountBadge">-{discountPercentage}%</div>
          <div className="originalPrice">
            <span className="planCurrency">₱</span>
            <span className="planAmount">{originalPrice.toLocaleString()}</span>
          </div>
          <div className="currentPrice">
            <span className="planCurrency">₱</span>
            <span className="planAmount">{price.toLocaleString()}</span>
            <span className="planPeriod">per month</span>
          </div>
        </div>
      </div>

      <div className="planBenefits">
        {benefits.map((benefit, benefitIndex) => (
          <div key={benefitIndex} className="planBenefit">
            <IonIcon
              icon={checkmarkOutline}
              className="planBenefitIcon"
              color="success"
            />
            <p className="planBenefitText">{benefit}</p>
          </div>
        ))}
      </div>

      <IonButton strong onClick={requestDemo} className="planRequestDemo">
        Request a demo
      </IonButton>

      <p className="planTrial">1-week free trial. Cancel anytime.</p>
    </div>
  );
};

export default Plan;
